// import React from "react";
// import blog from "./blog.module.css";
// import Blog1 from "./Blog1";
// import BlogBoxces from "./BlogBoxces";
// import Nav from "../Nav/Nav";
// import Footer from "../Footer/Footer";
// import useStore from "../../../Store";

// const Blog = () => {
//   const direction = useStore((state) => state.direction);
//   return (
//     <div style={{ direction }}>
//       <Nav />
//       <div className={blog.blog_container}>
//         <Blog1 />
//         <BlogBoxces />
//       </div>
//       <div className={blog.newsletter_container}>
//         <h2 className={blog.newsletter_title}>Subscribe to our newsletter</h2>
//         <form className={blog.newsletter_form}>
//           <input
//             type="text"
//             placeholder="First name"
//             className={blog.newsletter_input}
//           />
//           <input
//             type="email"
//             placeholder="Email address"
//             className={blog.newsletter_input}
//           />
//           <button type="submit" className={blog.newsletter_button}>
//             Subscribe Now
//           </button>
//         </form>
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default Blog;

import React, { useState } from "react";
import blog from "./blog.module.css";
import Blog1 from "./Blog1";
import BlogBoxces from "./BlogBoxces";
import Nav from "../Nav/Nav";
import Footer from "../Footer/Footer";
import useStore from "../../../Store";
import Swal from "sweetalert2";
import { newletters } from "../../../Services/APIrequests"; // Adjust the path if needed

const Blog = () => {
  const direction = useStore((state) => state.direction);
  const [formData, setFormData] = useState({ name: "", email: "" });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };


  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.name || !formData.email) {
    Swal.fire({
      icon: "warning",
      title: "Missing Fields",
      text: "Please fill all fields.",
    });
    return;
  }

  try {
    setLoading(true);
    const response = await newletters(formData);

    if (response.data.Status === 1) {
      Swal.fire({
        icon: "success",
        title: "Subscribed!",
        text: "Subscribed successfully!",
      });
      setFormData({ name: "", email: "" });
    } else {
      Swal.fire({
        icon: "error",
        title: "Subscription Failed",
        text: "Please try again later.",
      });
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops!",
      text: "An error occurred. Please try again.",
    });
  } finally {
    setLoading(false);
  }
};


  return (
    <div style={{ direction }}>
      <Nav />
      <div className={blog.blog_container}>
        <Blog1 />
        <BlogBoxces />
      </div>

      <div className={blog.newsletter_container}>
        <h2 className={blog.newsletter_title}>Subscribe to our newsletter</h2>
        <form className={blog.newsletter_form} onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="First name"
            className={blog.newsletter_input}
            value={formData.name}
            onChange={handleChange}
          />
          <input
            type="email"
            name="email"
            placeholder="Email address"
            className={blog.newsletter_input}
            value={formData.email}
            onChange={handleChange}
          />
          <button type="submit" className={blog.newsletter_button} disabled={loading}>
            {loading ? "Submitting..." : "Subscribe Now"}
          </button>
        </form>
        {message && <p style={{ marginTop: "10px", color: "#333" }}>{message}</p>}
      </div>

      <Footer />
    </div>
  );
};

export default Blog;

